import React from 'react'
import Icon from '@ant-design/icons';

export default (props) => {
  const {
    color, // цвет знака

    width,
    height,

    style: {
      width: style_width,
      height: style_height,
      color: style_color,
    } = {},
    ...rest
  } = props;

  const fill_color = color || style_color || '#4E4E4E';

  const w = width || style_width || 10;
  const h = height || style_height || 6;

  const SvgIcon = () => (
    <svg
      width={w}
      height={h}
      viewBox={`0 0 ${w} ${h}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 5.5L0 0.5L10 0.5L5 5.5Z"
        fill={fill_color}
      />
    </svg>
  );

  return <Icon component={SvgIcon} {...rest} />;
}
